export const lower = value => value && value.toLowerCase().trim();

export const normalizeName = value => {
  if (!value) return value;
  let normalizedValue = value;
  normalizedValue = normalizedValue.replace(new RegExp('ك', 'g'), 'ک');
  normalizedValue = normalizedValue.replace(new RegExp('ي', 'g'), 'ی');
  normalizedValue = normalizedValue.replace(new RegExp('‌', 'g'), ' ');
  return normalizedValue;
};
